import React from 'react';
import { Tag, Tooltip } from 'antd';
export function AddressPinStatus({ address }) {
  if (!address || address.latitude != null) return null;
  const reason = address.no_pin_note || address.no_pin_reason?.replace(/_/g, ' ');
  return <Tooltip title={reason || 'No coordinates saved'}><Tag color="warning">No pin{reason ? ` · ${reason}` : ''}</Tag></Tooltip>;
}
